import { Routes, Route, Navigate } from "react-router-dom";
import { AdministrationLayout } from "./AdministrationLayout";
import { TherapeuticAreasPage } from "./TherapeuticAreasPage";
import { DocumentRequirementsPage } from "./DocumentRequirementsPage";
import { MilestonesPage } from "./MilestonesPage";
import { AthenaMappingsPage } from "./AthenaMappingsPage";

/**
 * Clinops Administration sub-page. Mounted at /clinops/administration
 * and gated to the watershed-clinops-admin Cognito group via the
 * ``is_clinops_admin`` flag on the permissions response. The sidebar
 * hides the link for non-admins; backend endpoints behind each editor
 * 403 anyway, so URL-typing doesn't bypass anything material.
 */
export default function AdministrationRoutes() {
  return (
    <Routes>
      <Route path="/" element={<AdministrationLayout />}>
        <Route index element={<Navigate to="therapeutic-areas" replace />} />
        <Route path="therapeutic-areas" element={<TherapeuticAreasPage />} />
        <Route path="document-requirements" element={<DocumentRequirementsPage />} />
        <Route path="milestones" element={<MilestonesPage />} />
        <Route path="athena-mappings" element={<AthenaMappingsPage />} />
      </Route>
    </Routes>
  );
}
